var map = {
	"../clients/clients.module": [
		"./src/app/clients/clients.module.ts",
		"clients-clients-module"
	],
	"../contact-info/contact-info.module": [
		"./src/app/contact-info/contact-info.module.ts",
		"contact-info-contact-info-module"
	],
	"../create-client/create-client.module": [
		"./src/app/create-client/create-client.module.ts",
		"create-client-create-client-module"
	],
	"../create-events-news/create-events-news.module": [
		"./src/app/create-events-news/create-events-news.module.ts",
		"create-events-news-create-events-news-module"
	],
	"../create-store/create-store.module": [
		"./src/app/create-store/create-store.module.ts",
		"create-store-create-store-module"
	],
	"../customer-admin-list/customer-admin-list.module": [
		"./src/app/customer-admin-list/customer-admin-list.module.ts",
		"customer-admin-list-customer-admin-list-module"
	],
	"../customer-user-list/customer-user-list.module": [
		"./src/app/customer-user-list/customer-user-list.module.ts",
		"customer-user-list-customer-user-list-module"
	],
	"../customer-users/customer-users.module": [
		"./src/app/customer-users/customer-users.module.ts",
		"customer-users-customer-users-module"
	],
	"../dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"../event-des/event-des.module": [
		"./src/app/event-des/event-des.module.ts",
		"event-des-event-des-module"
	],
	"../events-news/events-news.module": [
		"./src/app/events-news/events-news.module.ts",
		"events-news-events-news-module"
	],
	"../history/history.module": [
		"./src/app/history/history.module.ts",
		"history-history-module"
	],
	"../new-user/new-user.module": [
		"./src/app/new-user/new-user.module.ts",
		"new-user-new-user-module"
	],
	"../notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"notifications-notifications-module"
	],
	"../order-des/order-des.module": [
		"./src/app/order-des/order-des.module.ts",
		"order-des-order-des-module"
	],
	"../orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"orders-orders-module"
	],
	"../pending-orders/pending-orders.module": [
		"./src/app/pending-orders/pending-orders.module.ts",
		"pending-orders-pending-orders-module"
	],
	"../product-configuration/product-configuration.module": [
		"./src/app/product-configuration/product-configuration.module.ts",
		"product-configuration-product-configuration-module"
	],
	"../store-admins-list/store-admins-list.module": [
		"./src/app/store-admins-list/store-admins-list.module.ts",
		"store-admins-list-store-admins-list-module"
	],
	"../store-des/store-des.module": [
		"./src/app/store-des/store-des.module.ts",
		"store-des-store-des-module"
	],
	"../store-tenants/store-tenants.module": [
		"./src/app/store-tenants/store-tenants.module.ts",
		"store-tenants-store-tenants-module"
	],
	"../store-users-list/store-users-list.module": [
		"./src/app/store-users-list/store-users-list.module.ts",
		"store-users-list-store-users-list-module"
	],
	"../stores-home/stores-home.module": [
		"./src/app/stores-home/stores-home.module.ts",
		"stores-home-stores-home-module"
	],
	"../update-order/update-order.module": [
		"./src/app/update-order/update-order.module.ts",
		"update-order-update-order-module"
	],
	"./app-shell/app-shell.module": [
		"./src/app/showcase/app-shell/app-shell.module.ts",
		"common",
		"app-shell-app-shell-module"
	],
	"./cart-des/cart-des.module": [
		"./src/app/cart-des/cart-des.module.ts",
		"cart-des-cart-des-module"
	],
	"./clients/clients.module": [
		"./src/app/clients/clients.module.ts",
		"clients-clients-module"
	],
	"./contact-info/contact-info.module": [
		"./src/app/contact-info/contact-info.module.ts",
		"contact-info-contact-info-module"
	],
	"./create-client/create-client.module": [
		"./src/app/create-client/create-client.module.ts",
		"create-client-create-client-module"
	],
	"./create-events-news/create-events-news.module": [
		"./src/app/create-events-news/create-events-news.module.ts",
		"create-events-news-create-events-news-module"
	],
	"./create-store/create-store.module": [
		"./src/app/create-store/create-store.module.ts",
		"create-store-create-store-module"
	],
	"./custom-components/custom-components.module": [
		"./src/app/showcase/custom-components/custom-components.module.ts",
		"common",
		"custom-components-custom-components-module"
	],
	"./customer-admin-list/customer-admin-list.module": [
		"./src/app/customer-admin-list/customer-admin-list.module.ts",
		"customer-admin-list-customer-admin-list-module"
	],
	"./customer-user-list/customer-user-list.module": [
		"./src/app/customer-user-list/customer-user-list.module.ts",
		"customer-user-list-customer-user-list-module"
	],
	"./customer-users/customer-users.module": [
		"./src/app/customer-users/customer-users.module.ts",
		"customer-users-customer-users-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./event-des/event-des.module": [
		"./src/app/event-des/event-des.module.ts",
		"event-des-event-des-module"
	],
	"./events-news/events-news.module": [
		"./src/app/events-news/events-news.module.ts",
		"events-news-events-news-module"
	],
	"./forgot-password/forgot-password.module": [
		"./src/app/forgot-password/forgot-password.module.ts",
		"forgot-password-forgot-password-module"
	],
	"./forms/filters/forms-filters.module": [
		"./src/app/forms/filters/forms-filters.module.ts",
		"forms-filters-forms-filters-module"
	],
	"./history/history.module": [
		"./src/app/history/history.module.ts",
		"history-history-module"
	],
	"./language-settings/language-settings.module": [
		"./src/app/language-settings/language-settings.module.ts",
		"language-settings-language-settings-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./modals/details/details.module": [
		"./src/app/modals/details/details.module.ts"
	],
	"./new-user/new-user.module": [
		"./src/app/new-user/new-user.module.ts",
		"new-user-new-user-module"
	],
	"./notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"notifications-notifications-module"
	],
	"./order-des/order-des.module": [
		"./src/app/order-des/order-des.module.ts",
		"order-des-order-des-module"
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"orders-orders-module"
	],
	"./pending-orders/pending-orders.module": [
		"./src/app/pending-orders/pending-orders.module.ts",
		"pending-orders-pending-orders-module"
	],
	"./product-configuration/product-configuration.module": [
		"./src/app/product-configuration/product-configuration.module.ts",
		"product-configuration-product-configuration-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./reset-password/reset-password.module": [
		"./src/app/reset-password/reset-password.module.ts",
		"reset-password-reset-password-module"
	],
	"./route-resolvers-ux/route-resolvers-ux.module": [
		"./src/app/showcase/route-resolvers-ux/route-resolvers-ux.module.ts",
		"common",
		"route-resolvers-ux-route-resolvers-ux-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./showcase/showcase.module": [
		"./src/app/showcase/showcase.module.ts",
		"showcase-showcase-module"
	],
	"./signup/signup.module": [
		"./src/app/signup/signup.module.ts",
		"signup-signup-module"
	],
	"./store-admins-list/store-admins-list.module": [
		"./src/app/store-admins-list/store-admins-list.module.ts",
		"store-admins-list-store-admins-list-module"
	],
	"./store-contact/store-contact.module": [
		"./src/app/store-contact/store-contact.module.ts",
		"store-contact-store-contact-module"
	],
	"./store-des/store-des.module": [
		"./src/app/store-des/store-des.module.ts",
		"store-des-store-des-module"
	],
	"./store-tenants/store-tenants.module": [
		"./src/app/store-tenants/store-tenants.module.ts",
		"store-tenants-store-tenants-module"
	],
	"./store-users-list/store-users-list.module": [
		"./src/app/store-users-list/store-users-list.module.ts",
		"store-users-list-store-users-list-module"
	],
	"./stores-home/stores-home.module": [
		"./src/app/stores-home/stores-home.module.ts",
		"stores-home-stores-home-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	],
	"./update-order/update-order.module": [
		"./src/app/update-order/update-order.module.ts",
		"update-order-update-order-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;